import { getServiceContexts as getServiceContextsGetter, getContext as getContextGetter } from '@/store/modules/contexts/getters';
import { useStore } from '@/utils/store';
import { ServiceContextMap, ServiceContextMapId, ServiceId } from '@ply-io/ply-front-shared-utilities';

export const useContextsGetters = () => {
	const { getter } = useStore();
	return {
		getServiceContexts: getter<(serviceId: ServiceId) => ServiceContextMap[]>(getServiceContextsGetter),
		getContext: getter<(contextId: ServiceContextMapId) => ServiceContextMap | undefined>(getContextGetter),
	};
};
